const PromotionsNameSpace = 'promotions';

const PromotionsActionTypes = Object.freeze({
    GetPromotions: 'GetPromotions',
    AddPromotion: 'AddPromotion',
    EditPromotion: 'EditPromotion',
    DeletePromotion: 'DeletePromotion',
});

const PromotionsMutationTypes = Object.freeze({
    SetPromotions: 'SetPromotions',
    SetChangedPromotion: 'SetChangedPromotion',
    SetDeletedPromotion: 'SetDeletedPromotion',
    SetEmptyPromotions: 'SetEmptyPromotions',
});

const PromotionsGetterTypes = Object.freeze({
    GetPromotions: 'GetPromotions',
    GetResponse: 'GetResponse',
    GetPerPage: 'GetPerPage',
});

export {
    PromotionsNameSpace,
    PromotionsActionTypes,
    PromotionsMutationTypes,
    PromotionsGetterTypes,
};
